import { Box, TextField } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import GenericFilterBox from "../common/GenericFilterBox";

const RfidCardFIlterAndSearch = (props: any) => {
  const { t } = useTranslation(["operation"]);
  const resetData = props.resetData;
  const rfidData = props.rfidData;
  const setRfidData = props.setRfidData;
  const resetForm = props.resetForm;
  const setResetForm = props.setResetForm;
  const setIsFirstTimeRender = props.setIsFirstTimeRender;

  const handleChange = (e: any) => {
    setRfidData({ ...rfidData, [e.target.name]: e.target.value });
  };

  const searchRfidCard = (e: any) => {
    e.preventDefault();
	setIsFirstTimeRender(false);
    setResetForm(!resetForm);
  };

  return (
    <Box>
      <form id="idRfidCardForm" onSubmit={(event) => searchRfidCard(event)}>
        <GenericFilterBox
          formId="idRfidCardForm"
          onReset={resetData}
          showExtrasFilters={false}
        >
          <Box>
            <TextField
              variant="standard"
              fullWidth
              id="plate"
              name="plate"
              value={rfidData.plate}
              label={t("rfidCard.plate")}
              onChange={(event) => handleChange(event)}
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>

          <Box>
            <TextField
              id="vin"
              name="vin"
              fullWidth
              label={t("rfidCard.vin")}
              value={rfidData.vin}
              onChange={(event) => handleChange(event)}
              variant="standard"
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>

          <Box>
            <TextField
              id="number"
              name="number"
              fullWidth
              label={t("rfidCard.number")}
              value={rfidData.number}
              onChange={(event) => handleChange(event)}
              variant="standard"
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>
        </GenericFilterBox>
      </form>
    </Box>
  );
};

export default RfidCardFIlterAndSearch;
